import { Flex, Spin } from "antd";
import styled from "styled-components";

export const StyledFullPageLoader = styled(Flex)`
  background: rgba(255, 255, 255, 0.7);
  position: absolute;
  top: 40px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  min-height: 100vh;
`;

export const Loader = () => {
  return (
    <StyledFullPageLoader align="center" justify="center">
      <Spin size="large" />
    </StyledFullPageLoader>
  );
};
